<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <div class="font-weight-medium ml-5" style="font-size: 20px">
          Idea Generation
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>      
        <v-card>
          <v-container fluid class="pa-5">
            <v-form @submit="getStockUniverse">
              <v-row>
                <v-col cols="12">
                  <p>Define Universe</p>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <p>Exposure to Factors</p>

                  <v-row v-for="item in styles" :key="item.code" style="margin: 0px;">
                    <v-col cols="4" style="font-weight: bold; color: #00bfc5; margin-top: 17px; padding: 0px;">
                      {{item.factor}}
                    </v-col>
                    <v-col cols="8" style="margin-left: -20px; padding: 0px;">
                      <v-btn-toggle
                        v-model="factors[item.code]"
                        tile
                        color="primary"
                        group
                        multiple
                      >
                        <v-btn value="low">
                          Low
                        </v-btn>
                        <v-btn value="avg">
                          Avg
                        </v-btn>
                        <v-btn value="high">
                          High
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="sector"
                    :items="sectors"
                    item-text="sector"
                    item-value="code"                
                    label="Sector"
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @click="toggleAllSector"
                      >
                        <v-list-item-action>
                          <v-icon :color="sector.length > 0 ? 'indigo darken-4' : ''">{{ iconSector }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>              
        
                  </v-select>

                  <v-select
                    v-model="currency"
                    :items="currencies"
                    item-text="currency"
                    item-value="currency"                
                    label="Currency"
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @click="toggleAllCurrency"
                      >
                        <v-list-item-action>
                          <v-icon :color="currency.length > 0 ? 'indigo darken-4' : ''">{{ iconCurrency }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="country"
                    :items="countries"
                    item-text="country"
                    item-value="country"                     
                    label="Country"
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @click="toggleAllCountry"
                      >
                        <v-list-item-action>
                          <v-icon :color="country.length > 0 ? 'indigo darken-4' : ''">{{ iconCountry }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>           
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    class="mr-3"
                    type="submit"
                    
                    :loading="buttonLoading"
                  >
                    Search
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-0"
                    @click="resetSearchForm()"
                  >
                    Reset
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <stock-universe :stock-universe="items" />
  </v-container>
</template>

<script>
export default {
  name: "appStocksList",
  components: {
    StockUniverse: () => import("@/components/StockUniverse")
  },
  data() {
    return {
      absolute: true,
      opacity: 0.46,
      overlay: false,
      factors: {},
      searchStocks: "",
      sector: [],
      currency: [],
      country: [],
      styles: [],
      countries: [],
      sectors: [],
      currencies: [],
      search: "",
      headers: [
        {
          sortable: false,
          text: "",
          align: "left"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Ticker", value: "ticker" },
        { text: "RIC", value: "ric" },
        { text: "ISIN", value: "isin" },
        { text: "Market Cap (loc ccy)", value: "market_cap" },
        { text: "Sector", value: "sector" },
        { text: "Country", value: "country" },
        { text: "Value", value: "Value" },
        { text: "Momentum", value: "Momentum" },
        { text: "Low Risk", value: "Risk" },
        { text: "Small Size", value: "Size" },
        { text: "Quality", value: "Quality" }
      ],
      items: [],
      listLoad: true,
      errorbar: false,
      buttonLoading: false
    };
  },
  mounted() {
    this.getFiltersFromApi();
    this.getListFromApi(null);
  },
  computed: {
    likesAllSectors() {
      return this.sector.length === this.sectors.length;
    },
    likesSomeSectors() {
      return this.sector.length > 0 && !this.likesAllSectors;
    },
    iconSector() {
      if (this.likesAllSectors) return "mdi-close-box";
      if (this.likesSomeSectors) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllCountries() {
      return this.country.length === this.countries.length;
    },
    likesSomeCountries() {
      return this.country.length > 0 && !this.likesAllCountries;
    },
    iconCountry() {
      if (this.likesAllCountries) return "mdi-close-box";
      if (this.likesSomeCountries) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllCurrencies() {
      return this.currency.length === this.currencies.length;
    },
    likesSomeCurrencies() {
      return this.currency.length > 0 && !this.likesAllCurrencies;
    },
    iconCurrency() {
      if (this.likesAllCurrencies) return "mdi-close-box";
      if (this.likesSomeCurrencies) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    toggleAllSector() {
      this.$nextTick(() => {
        if (this.likesAllSectors) {
          this.sector = [];
        } else {
          this.sector = this.sectors.slice();
        }
      });
    },
    toggleAllCountry() {
      this.$nextTick(() => {
        if (this.likesAllCountries) {
          this.country = [];
        } else {
          this.country = this.countries.slice();
        }
      });
    },
    toggleAllCurrency() {
      this.$nextTick(() => {
        if (this.likesAllCurrencies) {
          this.currency = [];
        } else {
          this.currency = this.currencies.slice();
        }
      });
    },
    async getFiltersFromApi() {
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(
          process.env.VUE_APP_API_HOST +
            "/get-stock-idea-generation-univ-filters",
          {
            headers: {
              Authorization: currentToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log(response.data)
          self.styles = response.data.style;
          self.countries = response.data.country;
          self.sectors = response.data.sector;
          self.currencies = response.data.currency;
          self.listLoad = false;
        })
        .catch(function() {
          self.listLoad = false;
          self.errorbar = true;
        });
    },
    getStockUniverse(e) {
      e.preventDefault();
      let bodyFilter = {
        factor: this.factors,
        sectors: this.sector,
        countries: this.country,
        currencies: this.currency
      };
      //console.log(bodyFilter)
      this.getListFromApi(bodyFilter);
      //this.overlay=false
    },
    async getListFromApi(filter) {
      var self = this;
      self.buttonLoading = true;
      self.overlay = true;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .post(
          process.env.VUE_APP_API_HOST + "/get-stock-idea-generation-universe",
          filter,
          {
            headers: {
              Authorization: currentToken,
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log(response.data);
          self.items = response.data;
          self.listLoad = false;
          self.buttonLoading = false;
          self.overlay = false;
        })
        .catch(function(/*error*/) {
          //console.log(error);
          self.listLoad = false;
          //self.errorbar = true
          self.buttonLoading = false;
          self.overlay = false;
        });
    },
    analyzeStock(item) {
      this.$router.push({ path: `/stocks/analyze/${item}` });
    },
    resetSearchForm() {
      this.searchStocks = "";
      this.sector = [];
      this.country = [];
      this.currency = "";
      this.factors = {};
    }
  }
};
</script>
